export class ReviewSorter {
    constructor() {
        this.sortReviews = this.sortReviews.bind(this);
        //default sort
        this.sortReviews("date", "desc");
    }
    sortReviews(field, direction) {
        const reviewList = Array.from(document.querySelectorAll("div[id^='review--']"));
        if (field === "date" && direction === "asc") {
            this.toggleActiveSort("sortDateAsc");
            reviewList.sort(this.sortByDateAsc);
        }
        if (field === "date" && direction === "desc") {
            this.toggleActiveSort("sortDateDesc");
            reviewList.sort(this.sortByDateDesc);
        }
        if (field === "stars" && direction === "asc") {
            this.toggleActiveSort("sortStarsAsc");
            reviewList.sort(this.sortByStarsAsc);
        }
        if (field === "stars" && direction === "desc") {
            this.toggleActiveSort("sortStarsDesc");
            reviewList.sort(this.sortByStarsDesc);
        }
        reviewList.forEach((review) => {
            review.parentNode?.appendChild(review);
        });
    }
    toggleActiveSort(selector) {
        document.querySelectorAll(".sortOption").forEach((element) => {
            element.classList.remove("active");
        });
        document.getElementById(selector)?.classList.add("active");
    }
    sortByDateAsc(item1, item2) {
        const date1 = new Date(item1.getAttribute("data-review-date") || "");
        const date2 = new Date(item2.getAttribute("data-review-date") || "");
        return date1 > date2 ? 1 : -1;
    }
    sortByDateDesc(item1, item2) {
        const date1 = new Date(item1.getAttribute("data-review-date") || "");
        const date2 = new Date(item2.getAttribute("data-review-date") || "");
        return date1 < date2 ? 1 : -1;
    }
    sortByStarsAsc(item1, item2) {
        return (parseInt(item1.getAttribute("data-review-stars") || "0") -
            parseInt(item2.getAttribute("data-review-stars") || "0"));
    }
    sortByStarsDesc(item1, item2) {
        return (parseInt(item2.getAttribute("data-review-stars") || "0") -
            parseInt(item1.getAttribute("data-review-stars") || "0"));
    }
}
